export interface ContactRow {
  firstName: string;
  lastName: string;
  email: string;
  phone?: string;
  company: string;
  jobTitle?: string;
  industry?: string;
  message?: string;
  isBookCallDialog?: boolean;
}

const SHEET_WEB_APP_URL =
  import.meta.env.VITE_SHEET_WEB_APP_URL || "https://script.google.com/macros/s/AKfycbxh2U6WIj_QdX6k0sWWmqcSNTQGRPHuDLLZjy6digrhf3ni6UOLDLGVL_lOJ8-Xnbznsw/exec";

export async function appendContactToSheet(row: ContactRow): Promise<boolean> {
  try {
    const payload = { ...row, _clientTimestamp: new Date().toISOString() };

    // Make it a “simple request” (no preflight) and avoid CORS blocking
    await fetch(SHEET_WEB_APP_URL, {
      method: "POST",
      mode: "no-cors", // important: send but don’t require CORS headers back
      headers: { "Content-Type": "text/plain;charset=UTF-8" }, // simple content-type
      body: JSON.stringify(payload),
    });

    // In no-cors mode we can’t read the response; assume success if no network error
    return true;
  } catch (e) {
    console.error("[Sheets] append failed:", e);
    return false;
  }
}
